import React, { FC, ComponentProps, useContext } from 'react'
import { Picker, PickerProps } from '@react-native-picker/picker'
import { useField, useFormikContext } from 'formik'

import { Element } from '../Element'
import { FormFieldContext } from './FormField'
import { TokensContext } from '../context'

export type FormPickerProps = PickerProps & { testID?: string }

export const FormPicker: FC<FormPickerProps> = (props) => {
  const formFieldContext = useContext(FormFieldContext)
  const [field, _meta, helpers] = useField(formFieldContext.name)

  return (
    <Element
      {...props}
      as={Picker}
      component='FormPicker'
      selectedValue={field.value}
      ref={formFieldContext.formElementRef}
      onValueChange={(itemValue, itemIndex) => {
        try {
          if (props.onValueChange) {
            props.onValueChange(itemValue, itemIndex)
          }
        } finally {
          helpers.setValue(itemValue)
        }
      }}
    />
  )
}

export const FormPickerItem: FC<ComponentProps<typeof Picker.Item>> = ({
  children,
  color,
  ...props
}) => {
  const tokensContext = useContext(TokensContext)

  return (
    <Element
      {...props}
      tokens={{ fontFamily: 'Inter', fontWeight: '400' }}
      as={Picker.Item}
      color={color ?? tokensContext.color.grey[8]}
    />
  )
}
